/**
 * exercise-handlers.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useLocation, matchPath } from 'react-router-dom';
import { Types } from 'utils/constants';
import { makeLocation } from 'utils/routing';
import { handlerExerciseCompletionStatus } from 'utils/record-status';
import { UserContext } from 'contexts/user/user-context';
import useRecordStore from 'contexts/record-store';
import DrawerMenuItem from 'components/menu-drawer/menu/drawer-menu-item';
import Icon from 'components/icon';
import CompletionStatusIcon from 'components/record-status-icons/completion';
import ReviewStatusIconExerciseSuper from 'components/record-status-icons/review/review-status-icon-exercise-super';
import MenuItemLabel from './menu-item-label';


const useStyles = makeStyles(theme => ({
  handlerItem: {
    marginLeft: theme.spacing(4),
    width: `calc(100% - ${theme.spacing(4)})`,
  }
}));


export default function ExerciseHandlers(props) {
  const {
    id,
    basePath,
    params
  } = props;
  const classes = useStyles();
  const { user } = React.useContext(UserContext);
  const location = useLocation();
  const recordStore = useRecordStore();
  const exerciseRecord = recordStore.useRecord(Types.Record.EXERCISE, id).ornull;
  const eventRecord = recordStore.useRecord(Types.Record.EVENT, exerciseRecord?.get()?.eventId).ornull;

  const haveExercise = Boolean(exerciseRecord);
  const haveEvent = Boolean(eventRecord);


  if (params.id !== id 
    || !haveExercise 
    || !haveEvent
    || !exerciseRecord.get().managedHandlers
  ) {
    return null;
  }


  return (
    <>
      {exerciseRecord.get().managedHandlers
        // fiter out handlers not attending
        .filter(handler => eventRecord.get().members.find(m => 
          m.id === handler.id 
          && (!m.isOptional || m.isAttending !== false)))
        .map(handler => {
          const menuId = `exercise-${exerciseRecord.get().id}-${handler.id}`;
          const to = makeLocation(
            basePath,
            'training',
            'viewHandlerAnswers',
            { exerciseId: id, handlerId: handler.id }
          );
          const isActive = Boolean(matchPath(
            location.pathname,
            to.pathname
          ));
          const label = <MenuItemLabel
            text={handler.name}
            statusIcons={<>
              {user.role.isSupervisor &&
              <ReviewStatusIconExerciseSuper
                reviewStats={handler.reviewStats}
                isAvailable={handler.userStats.complete > 0}
                to={to}
                showTooltip
              />}
              <CompletionStatusIcon 
                params={handlerExerciseCompletionStatus(
                  handler.userStats.complete,
                  handler.userStats.incomplete,
                  0, // supers & trainers don't care about outdated
                  eventRecord.get(),
                  handler.id,
                  handler.answers.length
                )} 
                showTooltip
                to={to}
              />
            </>}
          />;

          return <DrawerMenuItem
            key={menuId}
            id={menuId}
            icon={<Icon type='handler' />}
            label={label}
            to={to}
            isActive={isActive}
            isHighlighted={true}
            className={classes.handlerItem}
          />;
        })}
    </>
  );
}